/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#error-box[_ngcontent-%COMP%] {\n  width: 90%;\n  text-align: center;\n  position: absolute;\n  top: 20%;\n  margin: 0 5%;\n  color: #8b8b8b;\n}\n\n#error-box[_ngcontent-%COMP%]   img[_ngcontent-%COMP%] {\n  margin-bottom: 8%;\n  width: 100%;\n}\n\n.error-text[_ngcontent-%COMP%] {\n  \n  font-size: 0.3rem;\n}\n\n.top0[_ngcontent-%COMP%]{\n  top: 0 !important;\n}\n\n.btnWord[_ngcontent-%COMP%]{\n  border: none;\n  outline: none;\n  width: 3rem;\n  height: 0.75rem;\n  font-size: 0.3rem;\n  line-height: 0.75rem;\n  display: inline-block;\n  border-radius: 1rem;\n  margin-top: 1rem;\n  \n}\n\n#refreshBtn[_ngcontent-%COMP%]{\n  background-color: #7297e6;\n  color: white;\n}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/app-error/app-error.component.css.shim.ngstyle.js.pre-build-optimizer.js